<template>
  <el-card>
    <div
      slot="header"
      class="clearfix"
    >
      <span>Vevői megrendelések</span>
      <el-button
        style="float: right; margin-top: -5px;"
        type="success"
        size="small"
        @click="$router.replace('/sales/customer-orders/add')"
        icon="el-icon-plus"
        v-can="'customerorder.create'"
      >
        Új vevői megrendelés
      </el-button>
    </div>
    <div v-loading="loading" style="min-height: 81px;">
      <table-filter
        v-if="filterConfig"
        :config="filterConfig"
        action="customerOrder/fetchAll"
      />
    </div>
    <customer-order-list/>
    <template v-if="$route.meta.showAddCustomerOrderDialog">
      <customer-order-dialog
        type="add"
        :customer-order-id="$route.params.id"
      />
    </template>
    <template v-if="$route.meta.showUpdateCustomerOrderDialog">
      <customer-order-dialog
        :customer-order-id="$route.params.id"
        type="update"
      />
    </template>
    <template v-if="$route.meta.showCustomerOrderViewDialog">
      <customer-order-dialog
        :customer-order-id="$route.params.id"
        type="view"
      />
    </template>
  </el-card>
</template>

<script>
import customerOrderList from '../../components/sales/customerOrders/List';
import customerOrderDialog from '../../components/sales/customerOrders/Dialog';
import TableFilter from '../../components/TableFilter';

export default {
  components: {
    customerOrderList,
    customerOrderDialog,
    TableFilter,
  },
  data() {
    return {
      loading: false,
      filterConfig: null,
    };
  },
  async mounted() {
    this.loading = true;
    await this.setConfig();
    this.loading = false;
  },
  methods: {
    async setConfig() {
      this.filterConfig = [
        {
          type: 'text',
          name: 'receipt_number',
          label: 'Bizonylatszám',
          defaultSearch: true,
        },
        {
          type: 'date',
          name: 'created_at',
          label: 'Rögzítés dátuma',
        },
        {
          type: 'date',
          name: 'delivery_date',
          label: 'Szállítás dátuma',
        },
        {
          type: 'text',
          name: 'order_numbers',
          label: 'Megdendelésszám',
        },
        {
          type: 'select',
          options: [
            {
              label: 'Rögzítve',
              status: 'recorded'
            },
            {
              label: 'Összekészítésre vár',
              status: 'sent'
            },
            {
              label: 'Részben teljesítve',
              status: 'partly-done'
            },
            {
              label: 'Teljesítve',
              status: 'done'
            },
            {
              label: 'Lemondva',
              status: 'cancelled'
            },
          ],
          name: 'status',
          label: 'Státusz',
          labelCallback: status => status.label,
          valueKey: 'status',
        },
        {
          type: 'select',
          options: [
            {
              label: 'Igen',
              has_no_more_delivery: 0
            },
            {
              label: 'Nem',
              has_no_more_delivery: 1
            },
          ],
          name: 'has_no_more_delivery',
          label: 'Lesz még szállítás',
          labelCallback: status => status.label,
          valueKey: 'has_no_more_delivery',
        },
        {
          type: 'remote',
          name: 'customer_id',
          label: 'Vevő',
          labelCallback: partner => partner && `#${partner.id} ${partner.company.name}` || '',
          valueKey: 'id',
          remoteSearchParam: 'name',
          remoteAction: 'partner/search',
        },
        {
          type: 'text',
          name: 'address',
          label: 'Száll. cím',
        },
      ];
    },
  },
};
</script>
